<template>
  <div class="container">
    <div v-if="errorMessage" class="alert alert-danger d-flex justify-content-between">
      <span><em class="align-middle material-icons">error_outlined</em> {{ errorMessage }}</span>
      <button aria-label="Close" class="btn-close" type="button" @click.prevent="errorMessage=''"></button>
    </div>
    <div class="row text-center gy-3 row-cols-1">
      <div class="col">
        <img alt="Logo" class="logo" src="../assets/logo.png">
      </div>
      <div class="col">
        <h3>Meine Abmeldungen</h3>
        <h6>Melde dich mit deiner E-Mail-Adresse an.</h6>
      </div>
    </div>
    <div class="container">
      <form v-if="selfServiceStore.step === 'email'" class="row row-cols-1 g-3 login-form">
        <div class="alert alert-info d-flex flex-row align-items-center">
          <em class="align-middle material-icons">info_outline</em>
          <span class="px-3">
            Nach Eingabe der E-Mail-Adresse, über die du auch den Messdienerplan erhältst, bekommst du einen <b>sechsstelligen Code</b> zum Einloggen – ein Passwort ist nicht nötig.
          </span>
        </div>
        <div class="col">
          <label class="form-label" for="email">E-Mail</label>
          <input id="email" v-model="email" autofocus class="form-control" placeholder="E-Mail" required
                 name="email" type="email">
        </div>
        <div class="col">
          <button class="btn btn-primary mb-3" :disabled="requesting" @click.prevent="requestOtp">
            <span v-if="requesting" class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span>
            <em v-else class="align-middle material-icons">mail</em>
            Code anfordern
          </button>
        </div>
      </form>
      <form v-else class="row row-cols-1 g-3 login-form">
        <div class="col">
          <p>Wir haben dir einen Code an {{ selfServiceStore.email }} gesendet.</p>
          <label class="form-label" for="code">Code</label>
          <input id="code" v-model="code" autofocus class="form-control" placeholder="6-stelliger Code" required
                 name="code" type="text" inputmode="numeric" maxlength="6">
        </div>
        <div class="col text-start">
          <div class="form-check">
            <input id="remember" v-model="remember" class="form-check-input" type="checkbox">
            <label class="form-check-label" for="remember">Auf diesem Gerät angemeldet bleiben</label>
          </div>
        </div>
        <div class="col">
          <button class="btn btn-primary mb-3" :disabled="verifying" @click.prevent="verifyOtp">
            <span v-if="verifying" class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span>
            <em v-else class="align-middle material-icons">login</em>
            Anmelden
          </button>
        </div>
        <div class="col">
          <a class="link" @click.prevent="backToEmail">Andere E-Mail</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {useSelfServiceStore} from "@/stores/selfService";

export default {
  name: "SelfServiceLogin",
  setup() {
    const selfServiceStore = useSelfServiceStore();
    return {selfServiceStore};
  },
  data() {
    return {
      email: "",
      code: "",
      remember: true,
      errorMessage: "",
      requesting: false,
      verifying: false
    }
  },
  methods: {
    async requestOtp() {
      this.errorMessage = "";
      this.requesting = true;
      try {
        await this.selfServiceStore.requestOtp(this.email);
      } catch (e) {
        if (e.response && e.response.status === 429) {
          this.errorMessage = "Zu viele Anfragen. Bitte versuche es später erneut.";
        } else {
          this.errorMessage = (e.response && e.response.data.detail) || "Es ist ein Fehler aufgetreten.";
        }
      } finally {
        this.requesting = false;
      }
    },
    async verifyOtp() {
      this.errorMessage = "";
      this.verifying = true;
      try {
        await this.selfServiceStore.verifyOtp(this.code, this.remember);
      } catch (e) {
        this.errorMessage = (e.response && e.response.data.detail) || "Es ist ein Fehler aufgetreten.";
      } finally {
        this.verifying = false;
      }
    },
    backToEmail() {
      this.code = "";
      this.errorMessage = "";
      this.selfServiceStore.step = 'email';
    }
  }
}
</script>

<style scoped>
.login-form {
  width: 50%;
  min-width: 300px;
  margin: 0 auto;
}

a.link {
  cursor: pointer;
}

.logo {
  height: 80px;
}
</style>
